import { render } from "./VizioSlider.vue?vue&type=template&id=51f664bd"
import script from "./VizioSlider.vue?vue&type=script&lang=js"
export * from "./VizioSlider.vue?vue&type=script&lang=js"

import "./VizioSlider.vue?vue&type=style&index=0&id=51f664bd&lang=css"
script.render = render

export default script